import React from 'react';

const FillBlankQuestion = ({ question, answer, onAnswerChange, inputRef }) => {
  return (
    <div className="fillblank-question">
      <h3>{question.question}</h3>
      <textarea
        ref={inputRef}
        value={answer || ''}
        onChange={(e) => onAnswerChange(question.id, e.target.value)}
        placeholder="Type your answer here..."
        className="fillblank-input"
        rows={6}
        style={{ minHeight: '120px', resize: 'vertical' }}
      />
    </div>
  );
};

export default FillBlankQuestion;
